import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ConstantService } from '../../components/common/utils/constant.service';
import { ClienteXCiudad } from '../login/cliente_login';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos } from '../../components/common/utils/entities/util_entity';
import { Header } from 'primeng/primeng';

declare var jQuery: any;

@Injectable()
export class ActasService {
    private userEmpresa: ClienteXCiudad;
    private url = "utils";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

   
    getArchivo(consulta: Archivo): Observable<any> {
        let body = JSON.stringify(consulta);
        let headers = new Headers();
        if (consulta.Extension.toUpperCase() == "XLSX") {
            headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token"), 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        } else {
            headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token"), 'Accept': 'application/pdf' });
        }
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/getArchivoRepositorio", body, options).map(response => response)
            .catch(this.handleError);
    }

    getArchivosXCliente(datos: BuscaArchivos): Observable<Archivo[]> {
        let body = JSON.stringify(datos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/getArchivosXCliente", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    getArchivoGnrl(consulta: Archivo): Observable<any> {
        let body = JSON.stringify(consulta);
        let headers = new Headers();
        if (consulta.Extension.toUpperCase() == "XLSX") {
            headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token"), 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        } else {
            headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token"), 'Accept': 'application/pdf' });
        }
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/getArchivoRuta", body, options).map(response => response)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/actas/actas.service.ts